import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import WidgetHeader from '../Widget/WidgetHeader';
import RoundImage from '../../components/Image/RoundImage';
import { LocalRepState } from '../../utils/enums';
import { copyFor } from '../../copy/copy';

import defaultImage from '../../assets/images/localRepDefault.jpg';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import FindRepForm from '../../components/LocalRep/FindRepForm';

import { hideFindRepCard, loadLocalRep } from '../LocalRep/actions';

import { onGoToNextActionInsideCard } from '../Widget/actions';

const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

const Body = styled.div`
    flex: 1;
    margin: 1em 1em 0.4375em;
    display: flex;
    flex-direction: column;
`;

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top: 1.5em;
`;

const Sidebar = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    flex: 0 0 30%;
    margin-right: 1em;

    @media (max-width: 30em) {
        display: none;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    margin-top: 0.5em;
`;

const SidebarTitle = styled.h3`
    font-size: 1em;
    font-weight: bold;
    line-height: 1.25;
    color: #000;
    text-transform: capitalize;
    margin-top: 1em;
    margin-bottom: 0.125em;
`;

const SidebarDescription = styled.p`
    font-size: 0.875em;
    line-height: 1.43;
    color: #333;
`;

const ContentContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    form {
        padding-bottom: 10px;
    }
`;

const ContentTitle = styled.h2`
    font-size: 1.125em;
    font-weight: bold;
    line-height: 1.33;
    margin: 0 0 0.4444em;
`;

const ContentDescription = styled.div`
    object-fit: contain;
    font-family: Lato;
    font-size: 1em;
    line-height: 1.5;
    color: #000;
    margin-bottom: 1em;
`;

const nextActionDescriptionMapping = {
    call: copyFor('findReps', 'instructions', 'call'),
    email: copyFor('findReps', 'instructions', 'email'),
    tweet: copyFor('findReps', 'instructions', 'tweet'),
    petition: copyFor('findReps', 'instructions', 'petition')
};

const FindLocalRep = props => (
    <TransitionContainer zIndex={12}>
        <Container>
            <Overlay />
            <OverlayPublisher />
            <OverlayPartner transitionType="right-to-left" />
            <Body>
                <WidgetHeader />
                <Content>
                    <Sidebar>
                        <ImageContainer>
                            <RoundImage
                                src={
                                    props.actions.length < 2
                                        ? props.pictureUrl || defaultImage
                                        : defaultImage
                                }
                            />
                        </ImageContainer>
                        <SidebarTitle>
                            {copyFor('findReps', 'contactRep', props.nextActionType)}
                        </SidebarTitle>
                        <SidebarDescription>
                            {nextActionDescriptionMapping[props.nextActionType]}
                        </SidebarDescription>
                    </Sidebar>
                    <ContentContainer>
                        <ContentTitle>{copyFor('findReps', 'title')}</ContentTitle>
                        <ContentDescription>
                            {copyFor('findReps', 'provideAddress')}
                        </ContentDescription>
                        <FindRepForm
                            onBack={() =>
                                props.hideFindRepCard(
                                    props.cardType,
                                    props.nextActionType
                                )
                            }
                            onSubmit={data =>
                                props
                                    .loadLocalRep(
                                        data.homeAddressInput +
                                            ' ' +
                                            data.postalCodeInput,
                                        true,
                                        props.showOnlySenators
                                    )
                                    .then(() => {
                                        props.nextActionType === 'tweet'
                                            ? props.hideFindRepCard(
                                                  props.cardType,
                                                  props.nextActionType
                                              )
                                            : props.onGoToNextActionInsideCard(
                                                  props.nextActionIdentifier,
                                                  props.nextActionType,
                                                  false
                                              );
                                    })
                            }
                        />
                    </ContentContainer>
                </Content>
            </Body>
        </Container>
    </TransitionContainer>
);

FindLocalRep.propTypes = {
    nextActionType: PropTypes.string,
    hideFindRepCard: PropTypes.func.isRequired,
    loadLocalRep: PropTypes.func.isRequired,
    nextActionIdentifier: PropTypes.string,
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    pictureUrl: PropTypes.string,
    actions: PropTypes.array.isRequired,
    cardType: PropTypes.number.isRequired,
    showOnlySenators: PropTypes.bool.isRequired
};

const getNextActionType = state => {
    const action = state.widget.actions.find(
        a => a.identifier === state.localRep.nextActionIdentifier
    );
    return action != null ? action.type : null;
};

const pictureUrl = state => {
    const picture = state.widget.pictures.find(
        a => a.recipientPictureId === state.widget.activeAction.recipientPictureId
    );
    return (picture || {}).pictureUrl || defaultImage;
};

export default connect(
    state => ({
        nextActionType: getNextActionType(state),
        nextActionIdentifier: state.localRep.nextActionIdentifier,
        pictureUrl: pictureUrl(state),
        cardType: state.widget.cards[state.widget.activeAction.order - 1].type,
        actions: state.widget.actions
            .filter(function(a) {
                return state.widget.activeAction.type === 'petition'
                    ? a.id === state.widget.activeAction.id
                    : a.order === state.widget.activeAction.order;
            })
            .slice(0, 3)
            .sort(a => a.label),
        showOnlySenators:
            state.widget.activeAction.localRepresentativeState === LocalRepState.senators
    }),
    {
        loadLocalRep,
        hideFindRepCard,
        onGoToNextActionInsideCard
    }
)(FindLocalRep);



// WEBPACK FOOTER //
// ./src/containers/LocalRep/FindLocalRep.jsx